module.exports = __webpack_public_path__ + "dd8871171c9024337b74e0fe7dd58dd6.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/shirt-crab-s.png
// module id = 1389
// module chunks = 0